import React from 'react'

const TrackerNote = ({ text, linkLabel, href }) => (
  <div
    style={{
      fontStyle: 'italic',
      color: '#595959',
      marginBottom: 12,
      fontSize: 13,
    }}
  >
    <span style={{ color: '#d48806' }}>*Note:</span> {text}{' '}
    <a href={href} target="_blank" rel="noopener noreferrer">
      {linkLabel}
    </a>
  </div>
)

export default TrackerNote
